// extracted by mini-css-extract-plugin
export default {"reset":"LnXkwf","visuallyHidden":"Ab3uUL"};